// Core types and interfaces
export * from "./types";

// Factory functions for creating select components (enhanced with "Add New" support)
export * from "./factories";
export * from "./enhanced-factories";

// All select options organized by domain
export * from "./options";

// All select components organized by domain
export * from "./components";

// Legacy exports for backward compatibility
export { PrioritySelect } from "./PrioritySelect";
export { CategorySelect } from "./CategorySelect";
export { EntryTypeSelect } from "./EntryTypeSelect";
// ClientSelect, TicketSelect, and TemplateSelect are now exported from ./components/dynamic
